import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BlService } from 'src/app/_services/bl/bl.service';
import { LoteService } from 'src/app/_services/lote/lote.service';
import { LoteCabotajeService } from 'src/app/_services/loteCabotaje/lote-cabotaje.service';
import { CustomerBusinessName } from 'src/app/interfaces/lotes.interfaces';

/**
 * Componente de página contenedor de los movimientos de un lote de cabotaje (entradas y salidas),
 * que carga la información del lote y su razón social.
 */
@Component({
  selector: 'app-cabotaje-lote-movimiento',
  templateUrl: './cabotaje-lote-movimiento.component.html',
  styles: [
    `
    .movimiento li a {
      font-size: 2.2rem;
      text-decoration: none;
      color: #fff;
    }
    .title-midle {
      margin-top: 20px;
    }
    @media (max-width: 800px) {
      .movimiento {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
      }
      .movimiento li:first-child,
      .movimiento li:nth-child(3) {
        border-radius: 30px 0 0 30px;
      }
      .movimiento li:last-child,
      .movimiento li:nth-child(2) {
        border-radius: 0 30px 30px 0;
      }
    }
    `
  ]
})
export class CabotajeLoteMovimientoComponent implements OnInit {
  bachId: number = 0;
  customerBusinessName: string = '';
  customersBusinessName: CustomerBusinessName[] = [];

  constructor(
    private router: Router,
    private loteCabotajeService: LoteCabotajeService,
    private loteService: LoteService,
    private blServices: BlService,
  ) { }

  get lote() {
    return this.loteCabotajeService.loteInfoCabotage;
  }

  ngOnInit(): void {
    const parts = this.router.url.split("/");
    this.bachId = Number(parts[parts.length - 1]);
    this.loteService.currentCabotageBatch = this.bachId;
    this.blServices.path = ``;
    this.loteCabotajeService.getCabotageBatch(this.bachId)
    .subscribe( batch => {
      this.loteCabotajeService.loteInfoCabotage = batch[0];
      this.loteService.granel = this.lote.packing_id === 1 ? true : false;
      this.loteService.getCustomerBusinessName(this.lote.customer_id)
      .subscribe( customersBusinessName => {
        this.customersBusinessName = [...customersBusinessName];
        const client = this.customersBusinessName.find( client => client.id_business_name === this.lote.id_business_name);
        this.customerBusinessName = client?.business_name || '';
      });
    });
  }

  /**
   * Navega a la ruta de movimiento indicada para el lote actual.
   * @param path - Segmento de ruta del movimiento al que se navega.
   */
  navigateTo(path: string) {
    // this.router.navigate([`cabotage-${path}`,this.bachId]);
  }

}
